"use client";

import { useEffect } from "react";

import "./manufacturing.css";

const ArrowIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M5 12H19M13 6L19 12L13 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChartIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M4 19V5M4 19H21"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M8 15V11M12 15V8M16 15V5M20 15V10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const GearIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M12 8.5A3.5 3.5 0 1 0 12 15.5A3.5 3.5 0 0 0 12 8.5Z"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M19.4 13.2C19.5 12.8 19.5 12.4 19.5 12C19.5 11.6 19.5 11.2 19.4 10.8L21 9.6L19.1 6.4L17.2 7.2C16.6 6.7 15.9 6.3 15.1 6L14.8 4H11.2L10.9 6C10.1 6.3 9.4 6.7 8.8 7.2L6.9 6.4L5 9.6L6.6 10.8C6.5 11.2 6.5 11.6 6.5 12C6.5 12.4 6.5 12.8 6.6 13.2L5 14.4L6.9 17.6L8.8 16.8C9.4 17.3 10.1 17.7 10.9 18L11.2 20H14.8L15.1 18C15.9 17.7 16.6 17.3 17.2 16.8L19.1 17.6L21 14.4L19.4 13.2Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
);

const BoxIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3L20 7.5V16.5L12 21L4 16.5V7.5L12 3Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M4 7.5L12 12L20 7.5M12 12V21"
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3L19 6V11.5C19 16 16.2 19.3 12 21C7.8 19.3 5 16 5 11.5V6L12 3Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M9 12L11 14L15 10"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FactoryIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M3 20V10L9 13V8L15 11V6H20V20H3Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M7 20V17M11 20V17M15 20V17"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const WrenchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M14 6.5A5 5 0 0 0 7.5 13L3 17.5A2.1 2.1 0 1 0 6.5 21L11 16.5A5 5 0 0 0 17.5 10L14 13.5L10.5 10L14 6.5Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

const DatabaseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <ellipse
      cx="12"
      cy="5"
      rx="7"
      ry="3"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M5 5V12C5 13.7 8.1 15 12 15C15.9 15 19 13.7 19 12V5"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M5 12V19C5 20.7 8.1 22 12 22C15.9 22 19 20.7 19 19V12"
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </svg>
);

const LightbulbIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M9 18H15M10 21H14"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M8.5 14.5C7.5 13.5 7 12.2 7 10.8C7 8 9.2 6 12 6C14.8 6 17 8 17 10.8C17 12.2 16.5 13.5 15.5 14.5C14.7 15.3 14.3 16.1 14.3 17H9.7C9.7 16.1 9.3 15.3 8.5 14.5Z"
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </svg>
);

const PeopleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle
      cx="9"
      cy="8"
      r="3"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <circle
      cx="17"
      cy="9"
      r="2.5"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M3.5 19C3.8 15.8 5.8 14 9 14C12.2 14 14.2 15.8 14.5 19"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M14.5 14.8C17.4 14.6 19.5 16 20 18.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <rect
      x="4"
      y="5"
      width="16"
      height="15"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M8 3V7M16 3V7M4 10H20"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M8 14H10M14 14H16M8 17H10"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" />
    <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const TargetIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" fill="currentColor" />
    <path d="M8 12.5L10.5 15L16 9" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const WarningIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M12 3L22 20H2L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M12 10V14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="12" cy="17" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const WarehouseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M3 10L12 4L21 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 9V20H19V9" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M9 20V14H15V20" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
  </svg>
);

const iconMap = {
  material: BoxIcon,
  production: FactoryIcon,
  asset: WrenchIcon,
  quality: ShieldIcon,
  cost: DatabaseIcon,
  performance: ChartIcon,
};

const questions = [
  "Why is the production plan changing so frequently?",
  "Which materials will constrain production?",
  "Where is WIP building up?",
  "Why is actual production cost above standard?",
  "Which machines are reducing throughput?",
  "Which assets are likely to fail?",
  "Why is maintenance spend increasing without better uptime?",
  "Where are quality losses and rework occurring?",
  "Which plants or lines are underperforming?",
  "Where is inventory trapping working capital?",
];

const motionChainSteps = [
  {
    icon: BoxIcon,
    accent: "blue",
    title: "Material",
    items: ["Procurement", "BOM", "Inventory"],
  },
  {
    icon: FactoryIcon,
    accent: "blue",
    title: "Production",
    items: ["Orders", "Work Centres", "Machines"],
  },
  {
    icon: ShieldIcon,
    accent: "orange",
    title: "Quality",
    items: ["Inspection", "Testing", "Compliance"],
  },
  {
    icon: WarehouseIcon,
    accent: "purple",
    title: "Finished Goods",
    items: ["Warehouses", "Distribution", "Logistics"],
  },
];

const motionDemandPlanItems = [
  { icon: PeopleIcon, label: "Market | Forecast | Orders" },
  { icon: CalendarIcon, label: "S&OP | MPS | Capacity | Scheduling" },
];

const motionDeliveryItems = [
  { icon: TargetIcon, label: "On-time" },
  { icon: CheckIcon, label: "In-full" },
  { icon: ShieldIcon, label: "In-spec" },
];

const motionMetrics = [
  { icon: DatabaseIcon, key: "green", label: "COST" },
  { icon: GearIcon, key: "orange", label: "MARGIN" },
  { icon: ChartIcon, key: "purple", label: "CASH" },
];

const intelligenceAreas = [
  {
    key: "production",
    href: "/Operate",
    title: "Production Intelligence",
    text: "Plan • Order • Output\nYield • Variance\nBottlenecks • OEE",
  },
  {
    key: "material",
    href: "/knowledge/supply-chain",
    title: "Material Intelligence",
    text: "Material • BOM\nAvailability • Shortage\nInventory • Substitution",
  },
  {
    key: "asset",
    href: "/solutions/inventory-intelligence",
    title: "Asset Intelligence",
    text: "Equipment • Failure\nDowntime • Reliability\nSpares • Maintenance",
  },
  {
    key: "quality",
    href: "/52problem",
    title: "Quality Intelligence",
    text: "Defect • Scrap • Rework\nBatch • Compliance\nRoot Cause • CAPA",
  },
  {
    key: "cost",
    href: "/solutions/margin",
    title: "Cost Intelligence",
    text: "Material • Labour\nMachine • Energy\nOverheads • Variance",
  },
  {
    key: "performance",
    href: "/finance-performance",
    title: "Plant Performance",
    text: "Capacity • Throughput\nOEE • Schedule Adherence\nService Levels • Productivity",
  },
];

const planStats = [
  { icon: CalendarIcon, label: "PLAN", value: "10,000 units" },
  { icon: ChartIcon, label: "ACTUAL", value: "8,650 units" },
  { icon: WarningIcon, label: "GAP", value: "1,350 units", danger: true },
];

const rootCauseCards = [
  {
    title: "MATERIAL",
    href: "/knowledge/supply-chain",
    sub: "Shortage",
    image: "/assets/images/material.jpg",
  },
  {
    title: "MACHINE",
    href: "/Operate",
    sub: "Downtime",
    image: "/assets/images/machine.jpg",
  },
  {
    title: "PEOPLE",
    href: "/enterprise-transformation/successfactors",
    sub: "Shift / Capacity",
    image: "/assets/images/people.jpg",
  },
  {
    title: "QUALITY",
    href: "/52problem",
    sub: "Rejection",
    image: "/assets/images/quality.jpg",
  },
];

const rootCausePoints = [
  "Material delays",
  "Unplanned machine downtime",
  "Shift gaps",
  "Quality rejections",
  "Capacity constraints",
];

const changePoints = [
  "Improve material planning",
  "Reduce downtime",
  "Optimize shifts",
  "Increase capacity",
  "Strengthen quality checks",
];

const recoverPoints = [
  "Increase production efficiency",
  "Reduce losses",
  "Meet demand",
];

const businessProblems = [
  "Why is inventory increasing?",
  "Slow-moving inventory?",
  "Forecast accuracy?",
  "Stock-out risk?",
  "Production plan changing frequently?",
  "Machine downtime and reliability?",
  "Higher than standard production cost?",
  "Quality losses and rework?",
  "Working capital trapped in inventory?",
  "Low plant / line productivity?",
  "Maintenance spend increasing?",
  "Unplanned downtime?",
];

const systems = [
  ["SAP / S4HANA", "ERP"],
  ["MES", "Manufacturing Execution"],
  ["DMS", "Document Management"],
  ["WMS", "Warehouse Management"],
  ["QMS", "Quality Management"],
  ["CMMS", "Asset Management"],
  ["BI / Data", "Analytics & Reporting"],
];

export default function ManufacturingPage() {
  useEffect(() => {
    const cards = document.querySelectorAll(
      ".mfg-chain-col, .mfg-motion-bar, .mfg-metric-card, " +
      ".mfg-question-row, .mfg-questions-visual, .mfg-intelligence-card, " +
      ".mfg-root-cause-card, .mfg-analysis-strip, .mfg-problem-row, " +
      ".mfg-system-card, .mfg-data-block, .mfg-decision-bar"
    );

    if (!("IntersectionObserver" in window)) {
      cards.forEach((card) => card.classList.add("mfg-in-view"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mfg-in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="manufacturing-page">

      {/* =====================================================
          SECTION 1 — HERO
      ====================================================== */}
      <section className="mfg-hero-section">
        <div className="mfg-hero-background" />

        <div className="mfg-hero-overlay" />

        <div className="mfg-hero-content">
          <h1>
            From Material
            <br />
            to Machine to <span>Margin.</span>
          </h1>

          <p className="mfg-hero-description">
            Orane connects planning, materials, production, quality,
            maintenance, inventory and cost to help manufacturers
            improve throughput, reliability and profitability.
          </p>

          <div className="mfg-hero-actions">
            <a href="/tellusyourproblem#tell-details" className="mfg-primary-btn mfg-hero-cta-btn">
              Tell Us Your Manufacturing Problem
              <ArrowIcon />
            </a>

            <a href="#how-it-works" className="mfg-secondary-btn mfg-hero-cta-btn">
              See How It Works
              <span className="mfg-circle-arrow">
                <ArrowIcon size={15} />
              </span>
            </a>
          </div>
        </div>

        <div className="mfg-hero-stats">
          <div>
            <ChartIcon />
            <span>Higher</span>
            <strong>Throughput</strong>
          </div>

          <div>
            <GearIcon />
            <span>Lower</span>
            <strong>Operating Cost</strong>
          </div>

          <div>
            <ShieldIcon />
            <span>Better</span>
            <strong>Quality</strong>
          </div>

          <div>
            <span className="mfg-leaf-icon">◆</span>
            <span>Sustainable</span>
            <strong>Growth</strong>
          </div>
        </div>
      </section>


      {/* =====================================================
          SECTION 2 — QUESTIONS
      ====================================================== */}
      <section className="mfg-section mfg-questions-section">
        <div className="mfg-section-heading">

          <h2>
            The Questions <span>Manufacturing Leaders Ask</span>
          </h2>

          <p>Real questions. Real decisions. Real impact.</p>
        </div>

        <div className="mfg-questions-layout">
          <div className="mfg-questions-list">
            {questions.map((question, index) => (
              <div className="mfg-question-row" key={question}>
                <span className="mfg-question-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <p>{question}</p>

                <span className="mfg-question-arrow">
                  <ArrowIcon size={15} />
                </span>
              </div>
            ))}
          </div>

          <div className="mfg-questions-visual">
            <img
              src="/assets/images/the-questions-manufacturing-leaders-ask.jpg"
              alt="The Questions Manufacturing Leaders Ask"
            />
          </div>
        </div>
      </section>


      {/* =====================================================
          SECTION 3 — ENTERPRISE IN MOTION
      ====================================================== */}
      <section className="mfg-section mfg-motion-section" id="how-it-works">

        <div className="mfg-motion-card">

          <div className="mfg-motion-image">
            <img src="/assets/images/manufacturing.jpg" alt="Manufacturing production line" />
          </div>

          <div className="mfg-motion-content">

            <h2>
              The Manufacturing <span>Enterprise in Motion</span>
            </h2>

            <p className="mfg-motion-subtitle">
              From demand to delivery. An integrated view.
            </p>

            <div className="mfg-motion-bar">

              <span className="mfg-motion-bar-icon">
                <PeopleIcon />
              </span>

              <div className="mfg-motion-bar-main">

                <strong>Customer Demand &nbsp;|&nbsp; Plan</strong>

                <div className="mfg-motion-bar-items">

                  {motionDemandPlanItems.flatMap((item, index) => {
                    const nodes = [
                      <span className="mfg-motion-bar-item" key={item.label}>
                        <item.icon />
                        {item.label}
                      </span>,
                    ];

                    if (index < motionDemandPlanItems.length - 1) {
                      nodes.push(
                        <span className="mfg-motion-bar-divider" key={`div-${item.label}`} aria-hidden="true"></span>
                      );
                    }

                    return nodes;
                  })}

                </div>

              </div>

            </div>

            <div className="mfg-chain-grid">

              {motionChainSteps.map((step) => (
                <div className={`mfg-chain-col mfg-chain-col-${step.accent}`} key={step.title}>

                  <span className="mfg-chain-icon">
                    <step.icon />
                  </span>

                  <strong>{step.title}</strong>

                  <ul className="mfg-chain-list">
                    {step.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>

                </div>
              ))}

            </div>

            <div className="mfg-motion-bar">

              <span className="mfg-motion-bar-icon">
                <ArrowIcon />
              </span>

              <div className="mfg-motion-bar-main">

                <strong>Delivery to Customer</strong>

                <div className="mfg-motion-bar-items">

                  {motionDeliveryItems.flatMap((item, index) => {
                    const nodes = [
                      <span className="mfg-motion-bar-item" key={item.label}>
                        <item.icon />
                        {item.label}
                      </span>,
                    ];

                    if (index < motionDeliveryItems.length - 1) {
                      nodes.push(
                        <span className="mfg-motion-bar-divider" key={`div-${item.label}`} aria-hidden="true"></span>
                      );
                    }

                    return nodes;
                  })}

                </div>

              </div>

            </div>

            <div className="mfg-metrics-row">

              {motionMetrics.map((metric) => (
                <div className={`mfg-metric-card mfg-metric-${metric.key}`} key={metric.label}>
                  <span className="mfg-metric-icon">
                    <metric.icon />
                  </span>
                  <strong>{metric.label}</strong>
                </div>
              ))}

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          SECTION 4 — INTELLIGENCE AREAS
      ====================================================== */}
      <section className="mfg-section mfg-intelligence-section">
        <div className="mfg-section-heading">

          <h2>
            Six Manufacturing <span>Intelligence Areas</span>
          </h2>

          <p>End-to-end visibility. Measurable outcomes.</p>
        </div>

        <div className="mfg-intelligence-grid">
          {intelligenceAreas.map((item) => {
            const Icon = iconMap[item.key];

            return (
              <article className={`mfg-intelligence-card mfg-${item.key}`} key={item.title}>
                <div className="mfg-intelligence-icon">
                  <Icon />
                </div>

                <div className="mfg-intelligence-copy">
                  <h3>{item.title}</h3>

                  <p>
                    {item.text.split("\n").map((line) => (
                      <span key={line}>{line}</span>
                    ))}
                  </p>
                </div>

                <a
                  href={item.href}
                  className="mfg-mini-arrow"
                  aria-label={`Explore ${item.title}`}
                >
                  <ArrowIcon size={15} />
                </a>
              </article>
            );
          })}
        </div>
      </section>


      {/* =====================================================
          SECTION 5 — BUSINESS PROBLEMS
      ====================================================== */}
      <section className="mfg-section mfg-business-section">
        <div className="mfg-worked-question">

          <h2>A Worked Question</h2>

          <p className="mfg-worked-title">
            “Why is production output below plan?”
          </p>

          <div className="mfg-plan-comparison">
            {planStats.map((stat) => (
              <div className={stat.danger ? "mfg-gap-box" : undefined} key={stat.label}>
                <span className="mfg-stat-icon">
                  <stat.icon />
                </span>
                <div>
                  <strong>{stat.label}</strong>
                  <b>{stat.value}</b>
                </div>
              </div>
            ))}
          </div>

          <div className="mfg-root-cause-grid">
            {rootCauseCards.map((card) => (
              <a
                href={card.href}
                className="mfg-root-cause-card"
                key={card.title}
                style={{ backgroundImage: `url("${card.image}")` }}
              >
                <div className="mfg-root-cause-overlay"></div>
                <div className="mfg-root-cause-content">
                  <strong>{card.title}</strong>
                  <span>{card.sub}</span>
                </div>
                <span className="mfg-root-cause-arrow">
                  <ArrowIcon size={15} />
                </span>
              </a>
            ))}
          </div>

          <div className="mfg-analysis-strip">
            <span className="mfg-icon-badge">
              <SearchIcon />
            </span>
            <div className="mfg-analysis-copy">
              <strong>ROOT CAUSES</strong>
              <span>Analyse data across materials, machines, people and quality</span>
            </div>
            <div className="mfg-analysis-divider"></div>
            <ul className="mfg-analysis-points">
              {rootCausePoints.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </div>

          <div className="mfg-analysis-strip">
            <span className="mfg-icon-badge">
              <LightbulbIcon />
            </span>
            <div className="mfg-analysis-copy">
              <strong>WHAT CAN WE CHANGE?</strong>
              <span>Material | Schedule | Maintenance | Capacity | Quality | Shift</span>
            </div>
            <div className="mfg-analysis-divider"></div>
            <ul className="mfg-analysis-points">
              {changePoints.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </div>

          <div className="mfg-analysis-strip">
            <span className="mfg-icon-badge">
              <TargetIcon />
            </span>
            <div className="mfg-analysis-copy">
              <strong>RECOVER OUTPUT</strong>
              <span>Improve throughput and meet customer demand</span>
            </div>
            <div className="mfg-recover-points">
              {recoverPoints.map((point) => (
                <div className="mfg-recover-point" key={point}>
                  <CheckIcon />
                  <span>{point}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>


      {/* =====================================================
          SECTION 5B — 52 BUSINESS PROBLEMS
      ====================================================== */}
      <section className="mfg-section">
        <div className="mfg-problems-panel mfg-problems-panel-full">

          <h2>Relevant 52 Business Problems</h2>

          <p>
            Key manufacturing questions. Explore the full library.
          </p>

          <div className="mfg-problems-list">
            {businessProblems.map((problem, index) => (
              <div className="mfg-problem-row" key={problem}>
                <span>
                  {String(index + 1).padStart(2, "0")}
                </span>

                <p>{problem}</p>

                <ArrowIcon size={15} />
              </div>
            ))}
          </div>

          <a href="/52problem" className="mfg-text-link">
            Explore All 52 Business Problems
            <ArrowIcon />
          </a>
        </div>
      </section>


      {/* =====================================================
          SECTION 6 — ENTERPRISE SYSTEMS & DATA
      ====================================================== */}
      <section className="mfg-section mfg-systems-section">
        <div className="mfg-systems-header">
          <div>
            <h2>
              Enterprise Systems <span>&amp; Data</span>
            </h2>

            <p>
              Bring data together. Turn insights into action.
            </p>
          </div>
        </div>

        <div className="mfg-systems-grid">
          {systems.map(([title, subtitle], index) => (
            <div className="mfg-system-card" key={title}>
              <div className="mfg-system-icon">
                {index === 0 && <DatabaseIcon />}
                {index === 1 && <FactoryIcon />}
                {index === 2 && <BoxIcon />}
                {index === 3 && <BoxIcon />}
                {index === 4 && <ShieldIcon />}
                {index === 5 && <WrenchIcon />}
                {index === 6 && <ChartIcon />}
              </div>

              <strong>{title}</strong>
              <span>{subtitle}</span>
            </div>
          ))}
        </div>

        <div className="mfg-data-flow">
          <div className="mfg-data-block">
            <DatabaseIcon />

            <div>
              <strong>TRUSTED MANUFACTURING DATA</strong>
              <span>Transactional | Operational | IoT | External</span>
            </div>
          </div>

          <div className="mfg-data-block">
            <BoxIcon />

            <div>
              <strong>PLANT + PROCESS + PRODUCT CONTEXT</strong>
              <span>
                BOM | Routing | Work Centres | Assets | Quality | Cost | Demand
              </span>
            </div>
          </div>

          <div className="mfg-data-block">
            <LightbulbIcon />

            <div>
              <strong>MANUFACTURING INTELLIGENCE</strong>
              <span>Analytics | AI | Scenarios | Recommendations</span>
            </div>
          </div>
        </div>

        <div className="mfg-decision-bar">
          <strong>DECISION</strong>
          <ArrowIcon />
          <strong>ACTION</strong>
          <ArrowIcon />
          <strong>VALUE</strong>
        </div>
      </section>
    </main>
  );
}